import React from 'react';
import { Link } from 'react-router-dom';
import ArticleLayout from '../components/ArticleLayout';
import { SOBRE_PAGE } from '../lib/site';

const ANSWER =
  'O MiniMental.com.br é um site educacional brasileiro sobre o Mini Exame do Estado Mental (MEEM), com uma calculadora de pontuação por domínios e conteúdo de referência revisado periodicamente. Esta página explica quem produz e revisa o conteúdo, e qual é a política editorial do site.';

const RELATED = [
  {
    to: '/politica-de-privacidade',
    label: 'Política de Privacidade',
    note: 'como a calculadora trata os dados inseridos.'
  },
  {
    to: '/quem-pode-aplicar',
    label: 'Quem pode aplicar o Mini Mental',
    note: 'o escopo profissional da aplicação.'
  }
];

export default function Sobre() {
  return (
    <ArticleLayout page={SOBRE_PAGE} answer={ANSWER} related={RELATED} template="institutional">
      <section aria-labelledby="quem-escreve">
        <h2 id="quem-escreve" className="text-2xl mb-5">Quem escreve e revisa o conteúdo?</h2>
        <p className="text-[var(--text-muted)] mb-4">
          O conteúdo é organizado e revisado por Dr. Carlos Felipe, Médico — CRM-MG 105.721. A
          responsabilidade editorial inclui a seleção das referências científicas citadas, a
          revisão da precisão clínica dos textos e a atualização periódica do material diante de
          novas evidências.
        </p>
        <p className="text-[var(--text-muted)]">
          Dr. Carlos Felipe também mantém o{' '}
          <a
            href="https://blog.eidoc.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className=" text-[var(--primary)] hover:underline"
          >
            blog da Eidoc
          </a>
          , com conteúdo voltado a profissionais de saúde.
        </p>
      </section>

      <section aria-labelledby="politica-editorial">
        <h2 id="politica-editorial" className="text-2xl mb-5">Qual é a política editorial do site?</h2>
        <p className="text-[var(--text-muted)] mb-4">
          O conteúdo é escrito com base em literatura científica publicada, com preferência por
          estudos brasileiros quando disponíveis para os temas de escolaridade e faixa etária. Cada
          página cita suas fontes primárias. O site não reproduz o formulário oficial licenciado do
          Mini Exame do Estado Mental — apenas descreve os domínios avaliados e oferece uma
          calculadora para somar pontuações já obtidas com o instrumento validado utilizado por
          cada profissional.
        </p>
        <p className="text-[var(--text-muted)]">
          O conteúdo é revisado em ciclo semestral, com data de última revisão e próxima revisão
          previstas indicadas em cada página.
        </p>
      </section>

      <section aria-labelledby="calculadora-dados">
        <h2 id="calculadora-dados" className="text-2xl mb-5">Como a calculadora trata dados?</h2>
        <p className="text-[var(--text-muted)]">
          A calculadora do Mini Mental funciona inteiramente no navegador: nenhuma pontuação
          inserida é enviada ou armazenada em servidor. Detalhes completos estão na{' '}
          <Link to="/politica-de-privacidade" className=" text-[var(--primary)] hover:underline">
            Política de Privacidade
          </Link>.
        </p>
      </section>
    </ArticleLayout>
  );
}
